import { InputSearch } from "components/form/InputSearch";
import { setSearch } from "@/store/actions/samplesActions";
import { sampleSettingsSelector } from "store/slices/samplesSlice";
import { useAppDispatch, useAppSelector } from "store/store";

export const SamplesSearchInput = ({ className }: { className?: string }) => {
  const { search } = useAppSelector(sampleSettingsSelector);
  const dispatch = useAppDispatch();
  const handleSearch = (value: string) => {
    dispatch(setSearch(value));
  };

  return (
    <InputSearch
      searchTerm={search}
      handleSearch={handleSearch}
      type="secondary"
      placeholder="Search for essay examples"
      className={className}
    />
  );
};
